// extracted by mini-css-extract-plugin
module.exports = {"categoryFilter":"CategoryFilter_categoryFilter__hQs44","list":"CategoryFilter_list___FG30"};